import { render, staticRenderFns } from "./redPacket.vue?vue&type=template&id=585bad51&scoped=true"
import script from "./redPacket.vue?vue&type=script&lang=js"
export * from "./redPacket.vue?vue&type=script&lang=js"
import style0 from "./redPacket.vue?vue&type=style&index=0&id=585bad51&prod&lang=scss&scoped=true"
import style1 from "./redPacket.vue?vue&type=style&index=1&id=585bad51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585bad51",
  null
  
)

export default component.exports